export const QueryResultsActionTypes = {
  LOAD_QUERY_RESULTS_START: '[queryResults] LOAD_QUERY_RESULTS_START',

  LOAD_TABULAR_DATA_START: '[queryResults] LOAD_TABULAR_DATA_START',
  LOAD_TABULAR_DATA_SUCCESS: '[queryResults] LOAD_TABULAR_DATA_SUCCESS',
  LOAD_TABULAR_DATA_FAILURE: '[queryResults] LOAD_TABULAR_DATA_FAILURE',

  LOAD_HTML_PREVIEW_START: '[queryResults] LOAD_HTML_PREVIEW_START',
  LOAD_HTML_PREVIEW_SUCCESS: '[queryResults] LOAD_HTML_PREVIEW_SUCCESS',
  LOAD_HTML_PREVIEW_FAILURE: '[queryResults] LOAD_HTML_PREVIEW_FAILURE',

  LOAD_QDSEARCH_START: '[queryResults] LOAD_QDSEARCH_START',
  LOAD_QDSEARCH_SUCCESS: '[queryResults] LOAD_QDSEARCH_SUCCESS',
  LOAD_QDSEARCH_FAILURE: '[queryResults] LOAD_QDSEARCH_FAILURE',

  SELECT_FOR_DOWNLOAD: '[queryResults] SELECT_FOR_DOWNLOAD',
  RESET_FOR_DOWNLOAD: '[queryResults] RESET_FOR_DOWNLOAD',

  LOAD_DOWNLOAD_START: '[queryResults] LOAD_DOWNLOAD_START',
  LOAD_DOWNLOAD_SUCCESS: '[queryResults] LOAD_DOWNLOAD_SUCCESS',
  LOAD_DOWNLOAD_FAILURE: '[queryResults] LOAD_DOWNLOAD_FAILURE',
  LOAD_DOWNLOAD_PROGRESS: '[queryResults] LOAD_DOWNLOAD_PROGRESS',
  LOAD_DOWNLOAD_CANCEL: '[queryResults] LOAD_DOWNLOAD_CANCEL',
};